import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {DatetimeLabelComponent} from "./datetime-label.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
    ],
    declarations: [
        DatetimeLabelComponent,
    ],
    exports: [
        DatetimeLabelComponent,
    ],
})
export class DatetimeLabelModule {
}